// @ts-ignore - this makes tsc happy
import env from "configs/env"

// Define the type for the dataLayer array
interface DataLayer {
   push: (...args: any[]) => void
}

// Ensure window.dataLayer is typed correctly
declare global {
   interface Window {
      dataLayer: DataLayer
   }
}

const initGoogleAnalytics = () => {
   if (env.TARGET_ENV === "development") return // Show Zendesk in production & stage only
   // Add Google Analytics script here
   const script = document.createElement("script")
   script.src = "https://www.googletagmanager.com/gtag/js?id=G-MSZZX9J1VT"
   script.async = true

   const setupGoogleAnalytics = () => {
      // Add Google Analytics settings here
      // Initialize dataLayer if it doesn't exist
      window.dataLayer = window.dataLayer || { push: () => {} }

      // Define the gtag function
      function gtag(...args: any[]) {
         window.dataLayer.push(args)
      }

      // Use the gtag function
      gtag("js", new Date())
      gtag("config", "G-MSZZX9J1VT")
   }

   script.onload = () => {
      console.log("Google Analytics loaded successfully.")
      setupGoogleAnalytics()
   }
}

export default initGoogleAnalytics
